//
//
//
//
//

import AppTable from "./Table.vue";

export default {
	name: "TableContainer",
  components: {
		AppTable,
  },
	props: {
		contacts: Array
	},
  data() {
    return {};
  },
	methods: {},
  created() {},
};
